<style>
    .global-search-area {
        position: absolute;
        float: left;
        left: 50%;
        width: 40px;
        margin-left: -60px;
        z-index: 1;
    }
    .global-search-area .global-search-static {
        background-color: #2F4050;
        position: absolute;
        top: 100px;
        margin-left: -100px;
        z-index: 1;
        width: 325px;
        height: 60px;
        border-bottom-left-radius: 60px;
        border-bottom-right-radius: 60px;
    }
    .global-search-content {
        width: 250px;
        margin: auto;
        padding-top: 10px;
    }
</style>
<div class="wrapper wrapper-content">
    <div class="row">
        <div class="col-lg-12">
            <div class="text-center m-t-lg">
                <h1>
                    Rail360
                </h1>
                <h2 *ngIf="sfhAuth.isAuthenticated()">Welcome, {{sfhAuth.userInfo?.fullName}}</h2>
                <a [routerLink]="['/login']" *ngIf="!sfhAuth.isAuthenticated()" type="button" class="btn btn-primary btn-lg m-b">Login</a>
            </div>
        </div>        
    </div>    
</div>

<div *ngIf="sfhAuth.isAuthenticated()">
    <div class="global-search-area">
        <div class="global-search-static">
            <div class="global-search-content">
                <global-search #globalSearch id="rail360GlobalSearch" name="rail360GlobalSearch"></global-search>
            </div>
        </div>
    </div>
</div>